<template>
  <el-menu mode="vertical" class="side" :default-active="defaultActive">
    <template v-for="(menu) in sideMenu">
      <el-menu-item :index="menu.index" :key="menu.name" @click="handleMenuClick(menu)">
        <span class="top-tab-content">{{ menu.label }}</span>
      </el-menu-item>
    </template>
  </el-menu>
</template>

<script>
import _ from 'lodash';

export default {
  data: function () {
    return {}
  },
  computed: {
    defaultActive: function () {
      return _.find(this.sideMenu, (it) => this.$route.name.includes(it.name)).index
    },
    sideMenu: function () {
      let resMenu = [
        {index: '1-1', name: 'media', label: '媒体管理(Media Management)', action: {type: 'route', val: 'media'}},
        {index: '1-2', name: 'adzone', label: '广告位管理(Ad Slot Management)', action: {type: 'route', val: 'adzone'}}
      ]
      let reportMenu = [
        {index: '2-1', name: 'report', label: '数据报表(Data Chart)', action: {type: 'route', val: 'report'}}
      ]
      let accessGuideMenu = [
        {
          index: '3-1',
          name: 'accessGuide',
          label: '接入指引(Access Guide)',
          action: {type: 'route', val: 'accessGuide'}
        },
      ]
      let accountMenu = [
        {
          index: '3-1',
          name: 'account',
          label: '账户管理(Account Management)',
          action: {type: 'route', val: 'account'}
        },
      ]
      if (_.find(resMenu, (it) => this.$route.name.includes(it.name))) {
        return resMenu
      } else if (_.find(accessGuideMenu, (it) => this.$route.name.includes(it.name))) {
        return accessGuideMenu
      } else if (_.find(accountMenu, (it) => this.$route.name.includes(it.name))) {
        return accountMenu
      } else {
        return reportMenu
      }
    }
  },
  methods: {
    handleMenuClick: function (menu) {
      this.$router.push({name: menu.action.val}).catch(() => {
      });
    }
  }
}
</script>
<style scoped>
.side {
  height: 100%
}
</style>
